import data from "../../../../../src/ToggleSwitch/ToggleSwitch.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};